import React, {useState} from "react";
import {useStripe, useElements, CardElement} from "@stripe/react-stripe-js";
import {subscriptionServices} from "../../../service/subscriptionService";
import {
    Box,
    Typography,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    useTheme,
    Alert,
    Button
} from "@mui/material";
import Spinner from "../../spinner/Spinner";
import {SubscriptionDialog as Dialog} from "./SubscriptionDesign";
import {getSettingsColors} from "../SettingsDesign";
import {AuthPaymentNote} from "../../auth/AuthDesign";

function UpdatePaymentMethod(props) {
    const {onClose, open, reloadPaymentMethod} = props;

    const stripe = useStripe();
    const elements = useElements();

    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleSubmit = async event => {
        event.preventDefault();
        if (!stripe || !elements) return;
        setLoading(true);
        setErrorMsg("");

        const {error, paymentMethod} = await stripe.createPaymentMethod({
            type: "card",
            card: elements.getElement(CardElement)
        });

        if (error) {
            setLoading(false);
            setErrorMsg(error?.message);
        } else {
            await subscriptionServices.updatePaymentMethod(paymentMethod?.id).then(() => {
                reloadPaymentMethod();
                handleClose();
            }).catch((error) => {
                setErrorMsg(error?.response?.data?.error);
            }).finally(() => {
                setLoading(false);
            });
        }
    };

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return false;
        }
        setErrorMsg("");
        onClose();
    };

    return (
        <Dialog open={open}
                onClose={handleClose}
                fullWidth={true}
                fullScreen={fullScreen}
                aria-labelledby="update-payment-method"
        >
            <DialogTitle id="update-payment-method">
                Update payment method
                <Typography component="p" sx={{fontSize: 13, fontWeight: 400, color: 'text.secondary', mt: 0.75}}>
                    Choose the card used for your future subscription payments.
                </Typography>
            </DialogTitle>

            {loading && <Spinner size={32} overComponentBox={true}/>}

            <DialogContent>
                <form onSubmit={handleSubmit}>

                    {errorMsg !== "" &&
                        <Alert sx={{mb: 1}} variant="filled" severity="error">{errorMsg}</Alert>
                    }

                    <Box sx={{
                        bgcolor: theme => theme.palette.mode === 'light' ? '#fff' : getSettingsColors(theme).card, borderRadius: '10px', px: 1.5, py: 1.25,
                        '&:focus-within': {outline: '2px solid', outlineColor: 'primary.main'}
                    }}>
                        <CardElement
                            options={{
                                style: {
                                    base: {
                                        iconColor: theme.palette.text.secondary,
                                        fontSize: '16px',
                                        color: theme.palette.text.primary,
                                        '::placeholder': {
                                            color: theme.palette.text.secondary,
                                            fontSize: "14px"
                                        },
                                        '::selection': {
                                            backgroundColor: theme.palette.primary.main
                                        }
                                    },
                                    invalid: {
                                        color: theme.palette.error.main,
                                    },
                                },
                            }}
                        />
                    </Box>
                    <AuthPaymentNote/>
                </form>
            </DialogContent>
            <DialogActions>
                <Button type="button" color="inherit" variant="text" onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button type="submit" disabled={!stripe || !elements || loading} color="primary" variant="contained"
                        onClick={handleSubmit}>
                    Update
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UpdatePaymentMethod;
